module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-page-component"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('Login', {
    on: {
      "login": _vm.login,
      "logout": _vm.logout
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6fb4a32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/MyPages/LoginPage.vue
// module id = 1009
// module chunks = 0